var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iCheckbox',{attrs:{"value":_vm.rowProp.isChecked,"disabled":_vm.rowProp.isDisabled},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }